import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-processed-batch-payments',
  templateUrl: './processed-batch-payments.component.html',
  styleUrls: ['./processed-batch-payments.component.scss']
})
export class ProcessedBatchPaymentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
